var hasOwnProp = require('./hasOwnProp')

function objectEach (obj, iterate, context) {
  if (obj) {
    for (var key in obj) {
      if (hasOwnProp(obj, key)) {
        iterate.call(context, obj[key], key, obj)
      }
    }
  }
}

module.exports = objectEach



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/objectEach.js
// module id = Ibal
// module chunks = 141